import React from 'react';
import PropTypes from 'prop-types';

import { DATA_TYPES, FILTER_TYPES } from './constants';
import SelectionGroup from './SelectionGroup';
import Checkbox from './Checkbox';
import Chips from './Chips';
import Slider from './Slider';
import RangeSlider from './RangeSlider';
import Select from './Select';
import Input from './Input';

const Filter = props => {
	const { conditional, constraints, dataType, filterType, multiSelect } = props;

	switch (filterType) {
		case FILTER_TYPES.CHECKBOX:
			return <Checkbox {...props} />;
		case FILTER_TYPES.SELECTION_GROUP:
			return <SelectionGroup {...props} />;
		case FILTER_TYPES.SELECTION_GROUP_MULTIPLE:
			return <SelectionGroup multiple {...props} />;
		case FILTER_TYPES.CHIPS:
			return <Chips {...props} />;
		case FILTER_TYPES.CHIPS_MULTIPLE:
			return <Chips multiple {...props} />;
		case FILTER_TYPES.INPUT:
			return <Input {...props} formikProps={props} />;
		case FILTER_TYPES.SELECT:
			return <Select {...props} />;
		case FILTER_TYPES.SELECT_MULTIPLE:
			return <Select multiple {...props} />;
		case FILTER_TYPES.SLIDER:
			return <Slider {...props} />;
		case FILTER_TYPES.RANGE_SLIDER:
			return <RangeSlider {...props} />;
		default:
			if (conditional === true || dataType === DATA_TYPES.STRING) {
				return <SelectionGroup multiple={multiSelect} {...props} />;
			} else if (dataType === DATA_TYPES.BOOLEAN) {
				return <Checkbox {...props} />;
			} else if (dataType === DATA_TYPES.NUMERIC) {
				if (constraints.minOperator && constraints.maxOperator) {
					return <RangeSlider {...props} />;
				} else if (constraints.minOperator || constraints.maxOperator) {
					return <Slider {...props} />;
				} else {
					return <Input {...props} />;
				}
			} else {
				return null;
			}
	}
};

Filter.propTypes = {
	type: PropTypes.string.isRequired,
	quick: PropTypes.bool
};

export default React.memo(Filter);
